import {message} from 'antd'

const universalErrorHandler = (object, messageString) => {
  console.warn(object)
  message.error(messageString ? messageString : object)
}

export default universalErrorHandler
